import React from 'react'
import RateCallSimultaneousPreview from './RateCallSimultaneousPreview';
import { useEffect, useState } from 'react';
import { RECORD_STATE } from '../../../constants';
import { AgentButton } from 'global-components-library';
import { Singleton } from '../../../js/Singleton';
import DataAndLog from './DataAndLog';
import { updateInfoCall } from '../../../redux/actions/A_messages_to_SM';
import { useDispatch, useSelector } from 'react-redux';
import CallButtons from './CallButtons';

const language = new Singleton();


const ContainerSimultaneousRec = () => {   
  const { selectedRecord } = useSelector(state => state.preview);
  const [showDataLogDisp,setShowDataLogDisp] = useState(true);
  const [showOnlyData,setShowOnlyData] = useState(false);
  const [newData,setNewData] = useState({disabledUpdate:true,newArray:[]});
  const [showWrapUpView, setShowWrapUpView] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [isRateInDialog, setIsRateInDialog] = useState(false);

  useEffect(() => {
    if(selectedRecord.status === RECORD_STATE.WRAPUP || (selectedRecord.status === RECORD_STATE.ALERT && selectedRecord.messageStatus !== '1512' && selectedRecord.messageStatus !== '1508') || selectedRecord.status === RECORD_STATE.ABANDONED || selectedRecord.status === RECORD_STATE.WAITING_WRAPUP)
    {
      setShowWrapUpView(true)
    }
    else
    {
      setShowWrapUpView(false)
    }
  }, [selectedRecord.status,selectedRecord.messageStatus]);



  useEffect(() => {
    if(showWrapUpView || selectedRecord.status === RECORD_STATE.DIALOG)
    {
      setShowButtons(true);
    } 
    else 
    {
      setShowButtons(false);
    }
  }, [showWrapUpView, selectedRecord.status]);
  

  return (
    <div className= {`csr-container ${showOnlyData ? 'onlyData':''}`}>
      <div className='csr-container-rate-data-log'>
       {isRateInDialog && <div className='noAvailableLocked' />}
       {(showOnlyData && showWrapUpView )&& <div className='csr-container-arrow' onClick={()=>setShowOnlyData(o=>!o)}><i className='gcl-icon chevron'/></div>}
       {(!showOnlyData && showWrapUpView) &&
        <RateCallSimultaneousPreview
        setShowDataLogDisp={setShowDataLogDisp}
        newData={newData}/>
       }

       {(showDataLogDisp || showOnlyData) &&
        <DataAndLog
          showOnlyData={showOnlyData}
          showDataLogDisp={showWrapUpView ? showDataLogDisp : false}
          onChange={setNewData}
        />
       }
      </div>
      {showButtons && 
        <ContainerBtns
          showDataLogDisp={showDataLogDisp}
          showOnlyData={showOnlyData}
          setShowOnlyData={setShowOnlyData}
          recordToShow={selectedRecord}
          newData={newData}
          status={selectedRecord.status}
          isRateInDialog={isRateInDialog}
          setIsRateInDialog={setIsRateInDialog}/>
      }
    </div>
  )
};

const ContainerBtns =({  setShowOnlyData, showOnlyData,showDataLogDisp,recordToShow,newData, status, isRateInDialog, setIsRateInDialog})=>{
  const dispatch = useDispatch();
  const sendData = () => {
    let temp = [...newData.newArray]
    while(temp.length < 15)
    {
      temp.push('');
    }
    dispatch(updateInfoCall(recordToShow.callKey,recordToShow.camId,temp,recordToShow.callOutId))
  }
  return(
    <div className='csr-container-btns'>      
      <div className='csr-btn-main-container'>
        {(!showDataLogDisp && !showOnlyData) &&
            <div className={`csr-btn-container ${showDataLogDisp ? 'onlyData':''}`}>
              <div className='csr-container-arrow' onClick={()=>setShowOnlyData(o=>!o)}><i className='gcl-icon chevron-up'/></div>
              <div className='csr-label-container'>{language.getText('CallControlGUIContactDatatitle')}</div>
            </div>
        }
            
        {(showDataLogDisp || showOnlyData ) &&
          <div className='csr-btn-container'>
            <AgentButton type='primary'color={`${status === RECORD_STATE.DIALOG ? 'blue' : 'blue v2'}`} disabled={newData.disabledUpdate} onClick={sendData}>{language.getText("CallControlGUIContactDatabuttom")}</AgentButton>
          </div>
        }

        
      </div> 
      {status === RECORD_STATE.DIALOG && (
        <div className='call-buttons-container'>
          <CallButtons initialDialogTime={recordToShow.timeOnDialog} recordToShow={recordToShow} isRateInDialog={isRateInDialog} setIsRateInDialog={setIsRateInDialog}/>
        </div>
      )}     
      
    </div>          
  )
}


export default ContainerSimultaneousRec;



// WEBPACK FOOTER //
// ./src/components/workSpace/SimultaneosRecsPreview/ContainerSimultaneousRec.jsx